import React from 'react';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-5 align-items-center">
          <div className="col-lg-5" data-aos="fade-right" data-aos-delay="200">
            <div className="content">
              <h6 className="subtitle">About Us</h6>
              <h2>Driven by AI. Focused on Impact.</h2>
              <p>At Autobotics LLP, we design and deploy intelligent automation solutions that help businesses scale smarter and faster. As an ISO 9001:2015 certified company, we uphold the highest standards of quality, reliability, and innovation in every solution we deliver. Whether you're looking to automate complex workflows, build intelligent digital experiences, or integrate AI into your existing systems, Autobotics LLP is your trusted partner in digital transformation</p>
              <ul className="features-list">
                <li><i className="bi bi-check-circle-fill"></i><span>Cut costs and boost efficiency with smart automation.</span></li>
                <li><i className="bi bi-check-circle-fill"></i><span>Build intelligent systems powered by AI and RPA.</span></li>
                <li><i className="bi bi-check-circle-fill"></i><span>Drive growth with future-ready digital solutions.</span></li>
              </ul>
              <a href="#services" className="btn btn-primary">Discover More</a>
            </div>
          </div>
          <div className="col-lg-7" data-aos="fade-left" data-aos-delay="300">
            <div className="image-composition">
              <div className="image-main mb-3">
                <img src={process.env.PUBLIC_URL + '/assets/img/about/about-9.webp'} alt="Modern office with a team working" className="img-fluid" loading="lazy" />
              </div>
              <div className="image-secondary mb-3">
                <img src={process.env.PUBLIC_URL + '/assets/img/about/about-square-8.webp'} alt="Collaborative discussion" className="img-fluid" loading="lazy" />
              </div>
              <div className="stats-card d-flex gap-4">
                <div className="stats-item text-center">
                  <h3>22+</h3>
                  <p>Years of Expertise</p>
                </div>
                <div className="stats-item text-center">
                  <h3>50+</h3>
                  <p>Happy Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
